// Calls
const CallList = () => import('@/views/calls/CallList.vue')
const CallView = () => import('@/views/calls/CallView.vue')

export const callRoutes = [
  {
    path: '/calls',
    name: 'Calls',
    component: CallList,
    meta: {
      requireAuth: true,
      title: 'Calls'
    }
  },
  {
    path: '/calls/:id',
    name: 'ViewCall',
    component: CallView,
    meta: {
      requireAuth: true,
      title: 'View Call'
    }
  }
]
